import { httpClient } from "./http-client";
import { FeedbackInput } from "../common/types/feedback";

export const sendFeedback = async (
  feedback: string,
  contactEmail: string | undefined,
  url: string | undefined,
  customer: string,
  economicProfile: string
): Promise<void> => {
  await httpClient.post(
    `feedback/customers/${customer}/economic-profile/${economicProfile}`,
    {
      message: feedback,
      sender: contactEmail,
      url: url,
    } as FeedbackInput
  );
};
